import { EReportApiType } from './reports.type';
import type { ReportConfig } from './reports.type';

export const REPORT_CONFIGS: ReportConfig[] = [
    {
        id: 'chargebacks',
        apiType: EReportApiType.chargebacks,
        titleKey: 'payfac.pageReportsChargebacksTitle',
        descriptionKey: 'payfac.pageReportsChargebacksDescription',
        drawerTitleKey: 'payfac.pageReportsChargebacksDrawerTitle',
        drawerDescriptionKey: 'payfac.pageReportsChargebacksDrawerDescription',
    },
    {
        id: 'failed-transactions',
        apiType: EReportApiType.failed_transactions,
        titleKey: 'payfac.pageReportsFailedTransactionsTitle',
        descriptionKey: 'payfac.pageReportsFailedTransactionsDescription',
        drawerTitleKey: 'payfac.pageReportsFailedTransactionsDrawerTitle',
        drawerDescriptionKey: 'payfac.pageReportsFailedTransactionsDrawerDescription',
    },
    {
        id: 'seller-balance',
        apiType: EReportApiType.balance_seller,
        titleKey: 'payfac.pageReportsSellerBalanceTitle',
        descriptionKey: 'payfac.pageReportsSellerBalanceDescription',
        drawerTitleKey: 'payfac.pageReportsSellerBalanceDrawerTitle',
        drawerDescriptionKey: 'payfac.pageReportsSellerBalanceDrawerDescription',
    },
    {
        id: 'commissions',
        apiType: EReportApiType.comission,
        titleKey: 'payfac.pageReportsCommissionsTitle',
        descriptionKey: 'payfac.pageReportsCommissionsDescription',
        drawerTitleKey: 'payfac.pageReportsCommissionsDrawerTitle',
        drawerDescriptionKey: 'payfac.pageReportsCommissionsDrawerDescription',
    },
    {
        id: 'tax-commissions',
        apiType: EReportApiType.tax_commissions,
        titleKey: 'payfac.pageReportsTaxCommissionsTitle',
        descriptionKey: 'payfac.pageReportsTaxCommissionsDescription',
        drawerTitleKey: 'payfac.pageReportsTaxCommissionsDrawerTitle',
        drawerDescriptionKey: 'payfac.pageReportsTaxCommissionsDrawerDescription',
    },
];
